import { cn } from "@/utils/cn";
import { ClassValue } from "clsx";
import React from "react";

type TProps = {
  children?: React.ReactNode;
  className?: ClassValue;
  cardClass?: ClassValue;
  borderWidth?: number;
  borderBackground?: string;
  animationDuration?: string;
};

/**
 * A wrapper component that adds a rotating gradient border around its children.
 * Commonly used to highlight cards or promo blocks.
 *
 * @param props - Component props
 * @returns React component with rotating border effect.
 *
 * 🛠️ Usage Tip:
 * Add `relative z-10` to the child element to ensure it stacks above the animated border.
 */
const RotatingBorder = ({
  children,
  className,
  cardClass,
  borderWidth = 2,
  animationDuration = "6s",
}: TProps) => {
  return (
    <div
      className={cn("rot-border", className)}
      style={
        {
          "--bw": `${borderWidth}px`,
          "--speed": animationDuration,
          "--r": "8px",
        } as React.CSSProperties
      }
    >
      <div
        className={cn("z-10 rounded-[inherit]", cardClass)}
        style={{ padding: `${borderWidth}px` }}
      >
        {children}
      </div>
    </div>
  );
};

export default RotatingBorder;
